namespace AgerLMS.LMS {
    export interface DiscountUsersRow {
        Id?: number;
        DiscountId?: number;
        UserId?: number;
        DiscountTitle?: string;
        DiscountDescription?: string;
        Coupon?: string;
        StartDate?: string;
        ExpiryDate?: string;
        UserUsername?: string;
        UserDisplayName?: string;
        UseDate?: string;
    }

    export namespace DiscountUsersRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'LMS.DiscountUsers';
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = '?';
        export const updatePermission = '?';

        export declare const enum Fields {
            Id = "Id",
            DiscountId = "DiscountId",
            UserId = "UserId",
            DiscountTitle = "DiscountTitle",
            DiscountDescription = "DiscountDescription",
            Coupon = "Coupon",
            StartDate = "StartDate",
            ExpiryDate = "ExpiryDate",
            UserUsername = "UserUsername",
            UserDisplayName = "UserDisplayName",
            UseDate = "UseDate"
        }
    }
}
